export const defaults = {
  sidebarWidth: '240px'
};
